var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"excelExport"},[_c('a-button',{class:_vm.$style.excelButton,attrs:{"icon":"file-excel","loading":_vm.loading},on:{"click":_vm.exportExcel}},[_vm._v(" Excel ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }